import { BaseCheckbox } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import ConfigManager from 'components/config/ConfigManager'
import Titoletto from 'components/ui/Titoletto'
import { FRONTOFFICE_VERBALE_INFORMATIVA } from 'configuration/frontoffice'

const CFG = FRONTOFFICE_VERBALE_INFORMATIVA

export default function Informativa(props) {
  const {
    informativaAccettata,
    setInformativaAccettata,
  } = props

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_VERBALE_INFORMATIVA]}
      render={({ val, txt }) =>
        <>
          <Titoletto>{txt(CFG.TITOLO)}</Titoletto>
          {txt(CFG.INFORMATIVA)}

          <BaseCheckbox
            label={val(CFG.CONFERMA)}
            value={informativaAccettata}
            onChange={e => setInformativaAccettata(e.target.value)}
          />
        </>
      }
    />
  )
}
